module.exports = __webpack_public_path__ + "img/icon_map_all_c.1f13fc4f.png";